export enum GlobalConfigType {
  LoanStatus = 'LoanStatus',
  LoanFields = 'LoanFields',
  PagePermissions = 'PagePermissions',
  Footer = 'Footer',
  ConditionTypes = 'ConditionTypes',
  DocumentCategory = 'DocumentCategory',
  GlobalSettingV2 = 'GlobalSettingV2',
  LoanSubmissionHierarchy = 'LoanSubmissionHierarchy',
  GUARANTER_CONFIG = 'GUARANTER_CONFIG',
  ORDER_VALUATION = 'ORDER_VALUATION',
  ACCOUNT_TYPES = 'ACCOUNT_TYPES',
  PARTIES = 'PARTIES',
  EMAIL_OPTIONS = 'EMAIL_OPTIONS',
  GTM = 'GTM',
  RulesConfig = 'RulesConfig',
  IneligibleParties = 'IneligibleParties',
  SecondaryMarketing = 'SecondaryMarketing',
  PAYMENT_CODE = 'PAYMENT_CODE',
  PAYMENT_METHOD = 'PAYMENT_METHOD',
  ACCOUNT_PAYEES = 'ACCOUNT_PAYEES',
  ACCOUNT_SECTIONS = 'ACCOUNT_SECTIONS',
  ACCOUNTING_ACCOUNT_TYPES = 'ACCOUNTING_ACCOUNT_TYPES',
  EmailModalDefaults = 'EmailModalDefaults',
  DefaultSenderEmailByAccountType = 'DefaultSenderEmailByAccountType',
  ReportPlaceholders = 'ReportPlaceholders',
  LoanSubStatus = 'LoanSubStatus',
  ShippingInfoHeaders = 'ShippingInfoHeaders',
  UWConditionCategories = 'UWConditionCategories',
  LoanOverviewAccess = 'LoanOverviewAccess',
  HostWhiteLabel = 'HostWhiteLabel',
}
